export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6679.8bcf90cd.jpg";